import React from "react"
import { useLocation } from "react-router-dom"

import Header from "../screens/Header"

const Layout = ({ children }) => {
  const location = useLocation()

  const noHeaderRoutes = ["/projects"]

  const shouldShowHeader = !noHeaderRoutes.includes(location.pathname)

  return (
    <>
      {shouldShowHeader && <Header />}
      {children}
    </>
  )
}

export default Layout
